import { InfoCircleOutlined } from '@ant-design/icons'
import { Flex, Tag, Tooltip } from 'antd'
import { useTheme } from 'antd-style'

import {
  ApplyStatus,
  ApplyStatusColorMap,
  ApplyStatusPlatformTextMap
} from '@eastcoal/shared/enums/ApplyStatus'

import { ApplyListStatusRenderProps } from './interface'

export const ApplyListStatusRender = ({
  record: { status = ApplyStatus.WAIT_PLATFORM_AUDIT, reason }
}: ApplyListStatusRenderProps) => {
  const theme = useTheme()

  return (
    <Flex justify='center'>
      <Tag color={ApplyStatusColorMap[status]} variant='filled'>
        {ApplyStatusPlatformTextMap[status]}
      </Tag>
      {(status === ApplyStatus.FORBIDDEN ||
        status === ApplyStatus.PLATFORM_AUDIT_FAIL) && (
        <Tooltip title={reason} trigger='hover'>
          <InfoCircleOutlined style={{ color: theme.red }} />
        </Tooltip>
      )}
    </Flex>
  )
}
